import { experimentalStyled } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
var ChoiceButton = experimentalStyled(Button)(function (_ref) {
  var theme = _ref.theme;
  return "\n    text-transform: none;\n    \n    & .MuiTypography-root {\n      text-transform: none;\n      color: ".concat(theme.palette.primary.dark, ";\n      text-align: left;\n    }\n  ");
});
export { ChoiceButton };